if (!customElements.get('gift-wrap-option')) {
customElements.define('gift-wrap-option', class extends HTMLElement {
connectedCallback() {
if (this.ready) return; this.ready = true;
this.input = this.querySelector('[data-gift-wrap]');
this.hiddenInput = this.querySelector('input[type="hidden"]');
this.input.addEventListener('change', () => this.save());
this.notes = this.querySelector('[data-gift-wrap-notes]');
this.notes.addEventListener('change', () => this.save());
this.message = this.querySelector('[data-gift-message]');
this.message.addEventListener('change', () => this.save());
}
async save() {
const value = this.input.checked ? 'Yes' : 'No';
const previous = this.hiddenInput.value;
const notes = this.notes.value;
const message = this.message.value;
this.hiddenInput.value = value; this.input.disabled = true;
this.querySelector('[data-gift-wrap-status]').textContent = '';
try {
const root = window.Shopify?.routes?.root || '/';
const response = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Gift wrapping':value,'Gift wrapping instructions':notes,'Gift message':message}})});
if (!response.ok) throw new Error('Could not save');
await response.json();
document.querySelectorAll('gift-wrap-option').forEach(option => {
option.querySelector('input[type="hidden"]').value = value;
option.querySelector('[data-gift-wrap]').checked = value === 'Yes';
if (option !== this) {
option.querySelector('[data-gift-wrap-notes]').value = notes;
option.querySelector('[data-gift-message]').value = message;
}
});
} catch(error) {
this.hiddenInput.value = previous; this.input.checked = previous === 'Yes';
this.querySelector('[data-gift-wrap-status]').textContent = this.querySelector('[data-gift-wrap-error]').textContent;
} finally {this.input.disabled = false;}
}
});
}